import type {AuthSession} from '../auth';
import type {InterfaceModel,InterfaceRoute} from '../model';
import {navigationFor} from '../model';
import {Shell} from '../components/shell';
import {TenantOnboardingView} from '../views/tenant-onboarding-view';

export function AdminSurface({model,route,session,onSignOut}:{model:InterfaceModel;route:InterfaceRoute;session:AuthSession;onSignOut:()=>void}){
  const bootstrap=session.bootstrap!,claims=session.claims!,token=session.token!;
  const tenant=String(claims[bootstrap.tenantClaim]);
  const principal=String(claims[bootstrap.principalClaim]);
  return <Shell model={model} route={route} links={navigationFor(model,'admin')} scope={tenant} principal={principal} onSignOut={onSignOut}>
    <TenantOnboardingView key={route.identity} model={model} route={route} principal={principal} scope={tenant} token={token}/>
  </Shell>;
}
